'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  terms: {
    empty: 'Empty.',
    new: 'Add new term',
    next: 'Next page',
    previous: 'Previous page',
    form: {
      confirmSave: 'Do you want to save the changes\xA0?',
      dontSave: 'Do not save',
      name: 'Name',
      save: 'Save'
    }
  }
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/locales/en/terms.js
// module id = 2287
// module chunks = 0